import styled from "styled-components";
import "../../../../styles/variables.css";
import Flex from "../../../Flex";

export const BundleContainer = styled.div`
  text-align: center;

  @media (max-width: 600px) {
    width: 100%;
    height: 100%;
  }
`;

export const BundleText = styled.span`
  font-weight: 400;
  font-size: var(--fs15);
`;

export const Divider = styled.div`
  width: 100%;
  height: 2px;
  margin: 25px 0;
  border-top: 1px solid var(--border-light);
`;

export const AddMoreWalletsDescription = styled.span`
  margin: 10px 0 35px 0;
`;

export const BundleList = styled.div`
  width: 100%;
  height: 100%;
  max-height: 280px;
  margin-top: 10px;
  overflow-y: auto;
  -webkit-mask: linear-gradient(
      transparent 0px,
      rgb(255, 255, 255) 24px,
      rgb(255, 255, 255) calc(100% - 24px),
      transparent 100%
    ),
    linear-gradient(
      180deg,
      rgb(255, 255, 255) 0px,
      rgb(255, 255, 255) 20px,
      transparent 20px
    );
`;

export const BundleButtonWrapper = styled(Flex)`
  @media (max-width: 600px) {
    width: 80%;
    position: absolute;
    bottom: 20px;
  }
`;
